module.exports = __webpack_public_path__ + "img/SURVEY_MMSE.21ffb7ff.png";